'use strict';

import ServerSupport from './server-support';

let Server = {
  getHtml(url, options, extractReponseParts) {
    if (extractReponseParts === undefined) {
      extractReponseParts = true;
    }
    return fetch(url, options)
      .catch((error) => {
        console.error(error);
        return Promise.reject(error);
      })
      .then((response) => {
        if (!response.ok) {
          return Promise.reject(`Response status ${response.status} on fetch from ${url}`);
        } else {
          let responseText = response.text();
          if (extractReponseParts) {
            return responseText.then((text) => {
              return ServerSupport.extractResponseParts(text, response.url);
            });
          }
          return responseText;
        }
      });
  },
  getJson(url, options) {

    return fetch(url, options)
      .catch((error) => {
        console.error(error);
        return Promise.reject(error);
      })
      .then((response) => {
        if (!response.ok) {
          return Promise.reject(`Response status ${response.status} on fetch from ${url}`);
        } else {
          return response.json();
        }
      });
  }
};

export default Server;
